import PropTypes from 'prop-types';
import FoldableItem from './components/FoldableItem';

const fakeItems = [
    {
        id: 1,
        title: "Images",
        impact: 3,
        source: "IA",
        status: true,
        scores: { seo: 40, marketplace: 30, store: 60 },
        suggestion: '3 images recommandées (face, profil, porté)',
        defaultOpen: false,
    },
    {
        id: 2,
        title: "Description",
        impact: 3,
        source: "IA",
        status: false,
        scores: { seo: 20, marketplace: 45, store: 70 },
        suggestion: 'Sneakers de running légères avec semelle en mousse réactive et tige en mesh respirant. Conçues pour le confort au quotidien et les sessions d\'entraînement.',
        defaultOpen: false,
    },
    {
        id: 3,
        title: "Couleur",
        impact: 2,
        source: "IA",
        status: false,
        scores: { seo: 85, marketplace: 60, store: 90 },
        suggestion: 'Blanc (détecté par analyse image)',
        defaultOpen: false,
    },
    {
        id: 4,
        title: "Catégorie",
        impact: 2,
        source: "IA",
        status: true,
        scores: { seo: 70, marketplace: 50, store: 80 },
        suggestion: 'Chaussure > Running > Neutre',
        defaultOpen: false,
    },
    {
        id: 5,
        title: "SEO Meta",
        impact: 3,
        source: "IA",
        status: false,
        scores: { seo: 10, marketplace: 70, store: 85 },
        suggestion: 'Title: Sneakers Runner Pro - Chaussure Running Homme | SportMax\n' +
            'Desc: Découvrez les Sneakers Runner Pro de SportMax. Légères et confortables...',
        defaultOpen: false,
    },
    {
        id: 6,
        title: "Genre",
        impact: 1,
        source: "IA",
        status: false,
        scores: { seo: 80, marketplace: 75, store: 90 },
        suggestion: "Homme (détecté par analyse mannequin)",
        defaultOpen: true,
    },
    {
        id: 7,
        title: "Tailles",
        impact: 1,
        source: "IA",
        status: true,
        scores: { seo: 90, marketplace: 85, store: 95 },
        suggestion: null,
        defaultOpen: false,
    },
];

FieldSuggestion.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            title: PropTypes.string.isRequired,
            impact: PropTypes.number,
            source: PropTypes.string,
            status: PropTypes.bool,
            scores: PropTypes.array,
            suggestion: PropTypes.string,
            defaultOpen: PropTypes.bool,
        })
    ),
};

FieldSuggestion.defaultProps = {
    items: fakeItems,
};

function FieldSuggestion({items}) {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
            }}
        >
            {items.map((item) => (
                <FoldableItem
                    key={item.id}
                    title={item.title}
                    impact={item.impact}
                    source={item.source}
                    status={item.status}
                    scores={item.scores}
                    suggestion={item.suggestion}
                    defaultOpen={item.defaultOpen}
                    onGenerate={() => console.log("Generate", item.title)}
                    onEdit={() => console.log("Edit", item.title)}
                    onValidate={() => console.log("Validate", item.title)}
                    onCancel={() => console.log("Cancel", item.title)}
                />
            ))}
        </div>
    );
}


export default FieldSuggestion;
